














































import { Component, Vue, Prop } from 'vue-property-decorator'
import { addFilter } from '@russmedia/hooks'
import { Page, PianoCustomVariables } from '~base/common/types'

@Component<PromotionPage>({})
export default class PromotionPage extends Vue {
  @Prop({ type: Object, required: true }) readonly page!: Page

  // overwrite the one from the super class.
  mounted() {
    ;(
      document.querySelector('.promo-layout')! as HTMLDivElement
    ).style.backgroundImage = this.backgroundImage
    addFilter(
      'piano/customVariables',
      (customVariables: PianoCustomVariables[]) => {
        return [...customVariables, { name: 'page', value: this.page.slug }]
      }
    )
    this.$store.dispatch('paywall/executeExperience', this.page)
  }

  get backgroundImage() {
    const backgroundSrc = this.page.thumbnail
      ? this.page.thumbnail.src
      : `/marketing/default-background.jpg`
    return `url(${backgroundSrc})`
  }
}
